(function () {
    'use strict';

    var EVENTS = {
        'ready': 'sodTaggingInput:ready'
    };

    angular
        .module('sodCommon')
        .directive('sodTaggingInput', sodTaggingInput);

    function sodTaggingInput(lodash, $templateCache) {
        return {
            restrict: 'E',
            scope: {
                addItem: '&',
                options: '=?',
                tags: '=?',
            },
            templateUrl: 'common/components/tagging/input',
            controller: sodTaggingInputCtrl,
            controllerAs: 'vm',
            bindToController: true,
        };

        function sodTaggingInputCtrl($scope, $element, $interval, $timeout, lodash, GenericModel, $compile) {
            var vm = this;
            this.$onInit = function() {
                vm.intervals = {};
                vm.timeouts = {};
                vm.windowsOn = {};
                vm.toBeDestroyed = {};

                $timeout(function() {
                    init();
                });
                //
                $element.bind("keydown keypress", function (event) {
                    if (event.which === 13) {
                        // scope.$apply(function (){
                        //     scope.$eval(attrs.myEnter);
                        // });

                        event.preventDefault();
                    }
                });
            }

            function init() {
                vm.$findInputSodTaggingInput = $element.find('input.sod-tagging__input');

                getSodTaggingInput();
                getAriaOwnsId();
                emitReady();

                initAutoComplete();
                initAutoCompleteEvents();

                initDropDownStyleWidth();
                initWindowResizeSetDropDownWidth();

                initEvents();
            }

            function getSodTaggingInput() {
                vm.intervals.getSodTaggingInput = $interval(function () {
                    vm.$sodTaggingInput = vm.$findInputSodTaggingInput.length ?
                        lodash.head(vm.$findInputSodTaggingInput) : null;

                    if (vm.$sodTaggingInput) {
                        $interval.cancel(vm.intervals.getSodTaggingInput);
                    }
                }, 300);
            }

            function getAriaOwnsId() {
                vm.intervals.getAriaOwnsId = $interval(function () {
                    var hasAriaOwnsAttr = vm.$sodTaggingInput.hasAttribute('aria-owns');

                    if (vm.$sodTaggingInput && hasAriaOwnsAttr) {
                        vm.ariaOwnsId = vm.$sodTaggingInput.getAttribute('aria-owns');
                        $interval.cancel(vm.intervals.getAriaOwnsId);
                    }
                }, 300);
            }

            function emitReady() {
                vm.intervals.emitReady = $interval(function () {
                    if (vm.$sodTaggingInput && vm.ariaOwnsId) {
                        $scope.$emit(EVENTS.ready);
                        $interval.cancel(vm.intervals.emitReady);
                    }
                }, 300);
            }

            function initDropDownStyleWidth() {
                vm.intervals.initDropDownStyleWidth = $interval(function () {
                    var executed = onResizeDropDownWidth();
                    if (executed) {
                        $(vm.$findInputSodTaggingInput).prop('disabled', false);
                        $interval.cancel(vm.intervals.initDropDownStyleWidth);
                    }
                }, 300);
            }

            function initWindowResizeSetDropDownWidth() {
                vm.windowsOn.initWindowResizeSetDropDownWidth = {
                    type: 'resize',
                    cb: function () {
                        $scope.$apply(function () {
                            onResizeDropDownWidth();
                        });
                    }
                };

                $(window).on(
                    vm.windowsOn.initWindowResizeSetDropDownWidth.type,
                    vm.windowsOn.initWindowResizeSetDropDownWidth.cb
                );
            }

            function onResizeDropDownWidth() {
                if (vm.ariaOwnsId && vm.$sodTaggingInput) {
                    setDropDownStyleWidth();

                    return true;
                }

                return false;
            }

            function setSodTaggingInputWidth() {
                if (vm.$sodTaggingInput) {
                    vm.sodTaggingInputWidth = lodash.get(vm.$sodTaggingInput.getBoundingClientRect(), 'width');
                }
            }

            function setDropDownStyleWidth() {
                if (vm.ariaOwnsId) {
                    var $dropdownMenu = document.getElementById(vm.ariaOwnsId);
                    if ($dropdownMenu) {
                        setSodTaggingInputWidth();
                        $dropdownMenu.style.width = vm.sodTaggingInputWidth + 'px';
                    }
                }
            }

            function initAutoComplete() {
                var defaultOptions = {hint: false};
                var options = lodash.get(vm, 'options.autocomplete', defaultOptions);

                var dataset = getDataset();

                vm.$autocomplete = $(vm.$findInputSodTaggingInput).autocomplete(options, dataset);
                vm.toBeDestroyed.autocomplete = function () {
                    if (vm.$findInputSodTaggingInput) {
                        $(vm.$findInputSodTaggingInput).autocomplete('destroy');
                    }
                };

                function appendDataIfEmpty(query, data) {
                    var singleOption = {};
                    singleOption[lodash.get(vm, 'options.schema.label')] = query;
                    var hasOption = hasOptionOrTag(data, singleOption);

                    if (!hasOption) {
                        if (!hasOptionOrTag(vm.tags, singleOption)) {

                            return [singleOption].concat(data);
                        } else {
                            singleOption.added = true;
                            return [singleOption].concat(data);
                        }
                    }
                    //
                    return data;
                }

                function getDataset() {
                    return [{
                        source: function (query, cb) {
                            prepareSearchEndpoint();
                            if (vm.search_resource) {
                                vm.loading = true;
                                vm.search_resource[vm.search_method]({
                                    query: query,
                                }).$promise.then(function (res) {
                                    var dataset = determineAdded(res.data);

                                    var appendedDataIfEmpty = appendDataIfEmpty(query, dataset);
                                    cb(appendedDataIfEmpty);
                                    vm.loading = false;
                                });
                            } else {
                                var dataset = [];
                                var filteredOptions = lodash.filter(dataset, function (option) {
                                    return !hasOptionOrTag(vm.tags, option);
                                });

                                var appendedDataIfEmpty = appendDataIfEmpty(query, filteredOptions);

                                cb(appendedDataIfEmpty);
                            }

                            cb(appendedDataIfEmpty);
                        },
                        debounce: 400,
                        displayKey: lodash.get(vm, 'options.schema.label'),
                        templates: {
                            suggestion: function (suggestion) {
                                if (!lodash.has(suggestion, 'id')) {
                                    if (!hasOptionOrTag(vm.items, suggestion)) {
                                        var _template = TemplateEngine(
                                            $templateCache.get(lodash.get(vm, 'options.addTemplateUrl')),
                                            suggestion
                                        );
                                        return _template;
                                    }
                                } else {
                                    var _template = TemplateEngine(
                                        $templateCache.get(lodash.get(vm, 'options.templateUrl')),
                                        suggestion
                                    );
                                    return _template;
                                }
                                //
                                // return !lodash.has(suggestion, 'id') ?
                                //     TemplateEngine(
                                //         $templateCache.get(lodash.get(vm, 'options.addTemplateUrl')),
                                //         suggestion
                                //     ) : TemplateEngine(
                                //         $templateCache.get(lodash.get(vm, 'options.templateUrl')),
                                //         suggestion
                                //     );
                            },
                        },
                        cache: false,
                    }];
                }

                function determineAdded(data) {
                    return data.map(function (_item) {
                        var match = lodash.find(vm.tags, {select_id: _item.select_id});
                        if (match) {
                            _item.added = true;
                        }
                        return _item;
                    });
                }

                function hasOptionOrTag(items, item) {
                    var foundTag = lodash.findIndex(items, function (oItem) {
                        return lodash.lowerCase(
                            oItem[lodash.get(vm, 'options.schema.label')]
                        ) === _.lowerCase(
                            item[lodash.get(vm, 'options.schema.label')]
                        );
                    });
                    return foundTag >= 0;
                }
            }

            function initDropDownMenu(event) {
                vm.$dropdownMenu = new Tether({
                    element: document.getElementById(vm.ariaOwnsId),
                    target: vm.$sodTaggingInput,
                    attachment: 'top left',
                    targetAttachment: 'bottom left',
                    constraints: [
                        {
                            to: 'scrollParent',
                            attachment: 'together',
                            pin: true
                        },
                    ],
                });

                vm.toBeDestroyed.dropDownMenu = function () {
                    if (lodash.get(vm, '$dropdownMenu', false)) {
                        vm.$dropdownMenu.destroy();
                    }
                };
            }

            function initAutoCompleteEvents() {
                function handleAddItem(item) {
                    vm.addItem({item: item});
                    clearCurrentState();
                }

                function clearCurrentState() {
                    $(vm.$findInputSodTaggingInput).autocomplete('val', '');
                    // $(vm.$findInputSodTaggingInput).blur();

                    vm.timeouts.sodTaggingInputRefocus = $timeout(function () {
                        $(vm.$findInputSodTaggingInput).focus();
                    }, 300);
                }

                vm.$autocomplete.on(
                    'autocomplete:selected',
                    function (event, suggestion, dataset) {
                        $scope.$apply(function () {
                            if (!lodash.isEmpty(suggestion)) {
                                handleAddItem(suggestion)
                            }
                        });
                    }
                );

                vm.$autocomplete.on(
                    'autocomplete:updated',
                    function () {
                        onResizeDropDownWidth();
                    }
                );

                vm.$autocomplete.on(
                    'autocomplete:closed',
                    function () {
                        clearCurrentState();
                    }
                );


                // vm.$autocomplete.on(
                //     'autocomplete:opened',
                //     function () {  }
                // );


            }

            function initEvents() {
                $scope.$on(EVENTS.ready, initDropDownMenu);

                $scope.$on('$destroy', function () {
                    lodash.forEach(lodash.keys(vm.timeouts), function (oTimeout) {
                        $timeout.cancel(lodash.get(vm.timeouts, oTimeout));
                    });

                    lodash.forEach(lodash.keys(vm.intervals), function (oInterval) {
                        $interval.cancel(lodash.get(vm.timeouts, oInterval));
                    });

                    lodash.forEach(lodash.keys(vm.windowsOn), function (oWindowsOn) {
                        $(window).off(
                            lodash.get(oWindowsOn, 'type'),
                            lodash.get(oWindowsOn, 'cb')
                        );
                    });

                    lodash.forEach(lodash.keys(vm.toBeDestroyed), function (oToBeDestroyed) {
                        lodash.get(vm.toBeDestroyed, oToBeDestroyed, function () {
                        })();
                    });
                });
            }

            function TemplateEngine(html, options) {
                // var re = /<%([^%>]+)?%>/g, reExp = /(^( )?(if|for|else|switch|case|break|{|}))(.*)?/g, code = 'var r=[];\n', cursor = 0, match;
                // var add = function(line, js) {
                //     js? (code += line.match(reExp) ? line + '\n' : 'r.push(' + line + ');\n') :
                //         (code += line != '' ? 'r.push("' + line.replace(/"/g, '\\"') + '");\n' : '');
                //     return add;
                // };
                // while(match = re.exec(html)) {
                //     add(html.slice(cursor, match.index))(match[1], true);
                //     cursor = match.index + match[0].length;
                // }
                // add(html.substr(cursor, html.length - cursor));
                // code += 'return r.join("");';
                // return new Function(code.replace(/[\r\t\n]/g, '')).apply(options);

                var optionScope = $scope.$new(true);
                optionScope.optionModel = options;
                return $compile(html)(optionScope);

            };

            function prepareSearchEndpoint() {
                // var url = lodash.get(vm.opt)
                if (!vm.search_resource) {

                    var url = lodash.get(vm.options, 'search_route.url', null);

                    vm.search_resource = (url) ? new GenericModel(url) : null;
                    vm.search_method = lodash.get(vm.options, 'search_route.method', 'query');
                }
            }

            function checkIfAdded(dataset) {
                return dataset.map(function ($_item) {
                    if (lodash.filter(vm.tags, {searchText: $_item.searchText}).length > 0) {
                        return $_item._added = true;
                    }
                });
            }
        }
    }
})();